<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>
    <el-row class="">
      <div
        style="width: 100%;margin: 0 auto;margin-top: 20px;margin-bottom: 20px;border-style:solid;border-width:1px;border-color: #eee"
      >
        <el-form
          ref="form"
          :model="form"
          label-width="160px"
          class="demo-ruleForm"
        >
          <div>
            <el-row class="galy-header">
              货位整合
            </el-row>
            <el-row class="">
              <el-col
                :span="12"
                style="padding-top:31px;border-right:2px solid #ccc;"
              >
                <p style="margin-left: 80px">
                  <b>区域商品整合配置</b>
                </p>
                <el-form-item label="整合仓区:">
                  <el-select
                    v-model="form.checkIntegrationSpace"
                    multiple
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in spaceList"
                      v-if="!form.checkUpSpace.includes(item)"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="上架仓区:">
                  <el-select
                    v-model="form.checkUpSpace"
                    multiple
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in spaceList"
                      v-if="!form.checkIntegrationSpace.includes(item)"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否锁定上架仓位:">
                  <el-radio-group v-model="form.isUpSpaceLock">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="仓位属性">
                  <el-checkbox-group v-model="form.areaCheckedSpaceAttribute">
                    <el-checkbox
                      v-for="space in areaSpaceAttributeOptions"
                      :key="space.value"
                      :label="space.value"
                      >{{ space.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="配货状态">
                  <el-checkbox-group v-model="form.areaCheckedShippedStatus">
                    <el-checkbox
                      v-for="status in areaShippedStatusOptions"
                      :key="status.value"
                      :label="status.value"
                      >{{ status.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="前置仓商品">
                  <el-checkbox-group v-model="form.areaQianZhi">
                    <el-checkbox
                      v-for="status in areaQianZhiOptions"
                      :key="status.value"
                      :label="status.value"
                      >{{ status.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="在库时长:">
                  <el-input
                    v-model="form.areaInStockFromTime"
                    type=""
                    style="width: 20%"
                  ></el-input>
                  ——
                  <el-input
                    v-model="form.areaInStockToTime"
                    type=""
                    style="width: 20%"
                  ></el-input>
                </el-form-item>
                <el-form-item label="整合数量:">
                  单个任务商品件数小于等于
                  <el-input
                    v-model="form.areaIntegrationNum"
                    type=""
                    style="width: 20%"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="上架是否关联下架操作员:"
                  style="margin-left: 80px;"
                >
                  <el-switch v-model="form.areaConnect"></el-switch>
                </el-form-item>
                <el-form-item style="float: left">
                  <el-button type="primary" @click="onAreaSubmit"
                    >保存</el-button
                  >
                </el-form-item>
              </el-col>
              <el-col :span="6" style="padding-top:31px;">
                <p style="margin-left: 100px">
                  <b>sku集中整合配置</b>
                </p>
                <el-form-item label="整合仓区:">
                  <el-select
                    v-model="form.checkIntegrationSkuSpace"
                    multiple
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in stockShippingAreaList"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="仓位属性:"
                  prop="ccc"
                  style="margin-left: 30px"
                >
                  <el-checkbox-group v-model="form.skuCheckedSpaceAttribute">
                    <el-checkbox
                      v-for="space in skuSpaceAttributeOptions"
                      :key="space.value"
                      :label="space.value"
                      >{{ space.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="配货状态:" style="margin-left: 30px">
                  <el-checkbox-group v-model="form.skuCheckedShippedStatus">
                    <el-checkbox
                      v-for="status in skuShippedStatusOptions"
                      :key="status.value"
                      :label="status.value"
                      >{{ status.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item
                  label="单个sku占用货位数:"
                  style="margin-left: 90px"
                >
                  <el-input
                    v-model="form.fromSpaceNumBySku"
                    type=""
                    style="width: 50%"
                  ></el-input>
                  ——
                  <el-input
                    v-model="form.toSpaceNumBySku"
                    type=""
                    style="width: 50%"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="单个货位待整合sku商品数:"
                  style="margin-left: 90px"
                >
                  <el-input
                    v-model="form.fromSkuNumBySpace"
                    type=""
                    style="width: 30%"
                  ></el-input>
                  ——
                  <el-input
                    v-model="form.toSkuNumBySpace"
                    type=""
                    style="width: 30%"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="上架仓位存放件数限制:"
                  style="margin-left: 90px"
                >
                  指定仓位整合上架后的商品总数小于等于
                  <el-input
                    v-model="form.spaceSkuNum"
                    type=""
                    style="width: 50%"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="上架是否关联下架操作员:"
                  style="margin-left: 80px;"
                >
                  <el-switch v-model="form.skuConnect"></el-switch>
                </el-form-item>
                <el-form-item style="float: left">
                  <el-button type="primary" @click="onSkuSubmit"
                    >保存</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </el-row>
    <el-row> </el-row>
  </div>
</template>

<script>
import Global_ from "../../components/Global";
import HeaderTabs from "../wavepicking/components/HeaderTabs";
export default {
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: [],
      spaceList: [],
      stockShippingAreaList: [],
      form: {
        areaInStockFromTime: "",
        areaInStockToTime: "",
        areaIntegrationNum: "",
        areaConnect: false,
        fromSpaceNumBySku: "",
        toSpaceNumBySku: "",
        fromSkuNumBySpace: "",
        toSkuNumBySpace: "",
        skuConnect: false,
        areaCheckedSpaceAttribute: [],
        areaCheckedShippedStatus: [],
        skuCheckedSpaceAttribute: [],
        skuCheckedShippedStatus: [],
        checkIntegrationSpace: [],
        checkIntegrationSkuSpace: [],
        areaQianZhi: [],
        checkUpSpace: [],
        isUpSpaceLock: 1,
        spaceSkuNum: "",
      },
      loading: false,
      tableLoading: false,
      getUrl: "/erp/AdminSetting/getGoodsIntegrationSetting",
      postUrl: "/erp/AdminSetting/setGoodsIntegrationSetting",
      postAreaUrl: "/erp/AdminSetting/setAreaGoodsIntegrationSetting",
      postSkuUrl: "/erp/AdminSetting/setSkuGoodsIntegrationSetting",
      filterFold: false,
      supplyData: null,
      origin: Global_.origin,
      integrationSpaceOptions: [],
      upSpaceOptions: [],
      areaSpaceAttributeOptions: [
        {
          value: "0",
          label: "一位一品",
        },
        {
          value: "1",
          label: "一位多品",
        },
      ],
      skuSpaceAttributeOptions: [
        {
          value: "0",
          label: "一位一品",
        },
        {
          value: "1",
          label: "一位多品",
        },
      ],
      areaShippedStatusOptions: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "2",
          label: "否",
        },
      ],
      areaQianZhiOptions: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      skuShippedStatusOptions: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "2",
          label: "否",
        },
      ],
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (this.form[key] === undefined || this.form[key] === null) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.getUrl, this.filteredForm).then(res => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data.setting;
          this.spaceList = res.data.data.spaceList;
          this.stockShippingAreaList = res.data.data.stockShippingAreaList;
          if (this.resData.checkUpSpace != undefined) {
            this.form.checkUpSpace = this.resData.checkUpSpace;
          }
          if (this.resData.checkIntegrationSkuSpace != undefined) {
            this.form.checkIntegrationSkuSpace = this.resData.checkIntegrationSkuSpace;
          }
          if (this.resData.checkIntegrationSpace != undefined) {
            this.form.checkIntegrationSpace = this.resData.checkIntegrationSpace;
          }
          //this.getSpace();
          if (this.resData.areaQianZhi != undefined) {
            this.form.areaQianZhi = this.resData.areaQianZhi;
          }

          this.form.areaConnect =
            this.resData.areaConnect == "true" ? true : false;
          this.form.skuConnect =
            this.resData.skuConnect == "true" ? true : false;

          if (this.resData.areaCheckedSpaceAttribute != undefined) {
            this.form.areaCheckedSpaceAttribute = this.resData.areaCheckedSpaceAttribute;
          }

          if (this.resData.areaCheckedShippedStatus != undefined) {
            this.form.areaCheckedShippedStatus = this.resData.areaCheckedShippedStatus;
          }
          if (this.resData.skuCheckedSpaceAttribute != undefined) {
            this.form.skuCheckedSpaceAttribute = this.resData.skuCheckedSpaceAttribute;
          }
          if (this.resData.skuCheckedShippedStatus != undefined) {
            this.form.skuCheckedShippedStatus = this.resData.skuCheckedShippedStatus;
          }

          this.form.areaIntegrationNum = this.resData.areaIntegrationNum;
          this.form.spaceSkuNum = this.resData.spaceSkuNum;
          this.form.isUpSpaceLock = this.resData.isUpSpaceLock;

          if (this.resData.areaInStockTime != undefined) {
            this.form.areaInStockFromTime = this.resData.areaInStockTime.areaInStockFromTime;
            this.form.areaInStockToTime = this.resData.areaInStockTime.areaInStockToTime;
          }
          if (this.resData.skuNumBySpace != undefined) {
            this.form.fromSkuNumBySpace = this.resData.skuNumBySpace.fromSkuNumBySpace;
            this.form.toSkuNumBySpace = this.resData.skuNumBySpace.toSkuNumBySpace;
          }
          if (this.resData.spaceNumBySku != undefined) {
            this.form.fromSpaceNumBySku = this.resData.spaceNumBySku.fromSpaceNumBySku;
            this.form.toSpaceNumBySku = this.resData.spaceNumBySku.toSpaceNumBySku;
          }
        }
      });
    },
    getSpace() {
      if (this.resData.checkUpSpace != undefined) {
        for (let item of this.resData.checkUpSpace) {
          let index = this.spaceList.indexOf(item);
          if (index != -1) {
            this.spaceList.splice(index, 1);
          }
        }
      }
      if (this.resData.checkIntegrationSpace != undefined) {
        for (let item of this.resData.checkIntegrationSpace) {
          let index = this.spaceList.indexOf(item);
          if (index != -1) {
            this.spaceList.splice(index, 1);
          }
        }
      }
    },
    onSubmit() {
      this.loading = true;
      this.$http.post(this.postUrl, this.filteredForm).then(res => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success("操作成功");
        }
      });
    },
    onAreaSubmit() {
      this.loading = true;
      this.$http.post(this.postAreaUrl, this.filteredForm).then(res => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success("操作成功");
        }
      });
    },
    onSkuSubmit() {
      this.loading = true;
      this.$http.post(this.postSkuUrl, this.filteredForm).then(res => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success("操作成功");
        }
      });
    },
  },
};
</script>

<style scoped>
.galy-header {
  background-color: #eee;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting/GoodsIntegration.vue